export default {
  modalContainer: {
    display: 'none'
  }
};
